import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import axios from "axios";
import ApiHelper from "@/helpers/apiHelper.ts";
import authService from "@/services/authService.ts";

export const useContestStore = defineStore('contest',  {
    state: () => ({
        contestInfo: {}
    }),
    actions: {
        async getContestInfo() {
            try {
                const token = await (new authService()).getToken();
                const response = await axios.get(ApiHelper.getContestInfoUrl(), {
                    headers: {'X-Form-Token': token}
                });
                this.contestInfo = response.data?.data || {};
            } catch (error) {
                console.error("Error fetching contest information:", error);
            }
        }
    }
})
